import { freightPickupWindowIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteFreightPickupWindow = {
  name: "deleteFreightPickupWindow" as const,
  input: z.object({ id: freightPickupWindowIdFormat.schema }),
  output: z.object({}),
};
